export const RefundRequestData = [
  {
    id: 1,
    profile: '/assets/img/services/service-03.jpg',
    texts: 'Computer Repair',
    dates: '28 Sep 2022',
    customer: '/assets/img/customer/user-01.jpg',
    customer1: '/assets/img/customer/user-03.jpg',
    customerName: 'John Smith',
    customerName1: 'Sharon',
    amt: '$80',
    pending: 'Pending',
    reason: 'Not satisfied',
    bg: 'badge-pending',
  },
  {
    id: 2,
    profile: '/assets/img/services/service-02.jpg',
    texts: 'Car Repair Services',
    dates: '22 Sep 2022',
    customer: '/assets/img/customer/user-04.jpg',
    customer1: '/assets/img/customer/user-05.jpg',
    customerName: 'Johnny',
    customerName1: 'Pricilla',
    amt: '$50',
    pending: 'Completed',
    reason: 'Testing',
    bg: 'badge-active',
  },
  {
    id: 3,
    profile: '/assets/img/services/service-04.jpg',
    texts: 'Steam Car Wash',
    dates: '20 Sep 2022',
    customer: '/assets/img/customer/user-06.jpg',
    customer1: '/assets/img/customer/user-02.jpg',
    customerName: 'Robert',
    customerName1: 'Amanda',
    amt: '$50',
    pending: 'Completed',
    reason: "I don't want this service.",
    bg: 'badge-active',
  },
  {
    id: 4,
    profile: '/assets/img/services/service-09.jpg',
    texts: 'House Cleaning ',
    dates: '08 Sep 2022',
    customer: '/assets/img/customer/user-09.jpg',
    customer1: '/assets/img/customer/user-01.jpg',
    customerName: 'Sharonda',
    customerName1: 'James',
    amt: '$34',
    pending: 'Completed',
    reason: 'Testing Refund',
    bg: 'badge-active',
  },
  {
    id: 5,
    profile: '/assets/img/services/service-03.jpg',
    texts: 'Computer Repair',
    dates: '23 Sep 2022',
    customer: '/assets/img/customer/user-01.jpg',
    customer1: '/assets/img/customer/user-03.jpg',
    customerName: 'John Smith',
    customerName1: 'Sharon',
    amt: '$46',
    pending: 'Approved',
    reason: 'Just Testing Purpose.',
    bg: 'badge-active',
  },
  {
    id: 6,
    profile: '/assets/img/services/service-02.jpg',
    texts: 'Car Repair Services',
    dates: '30 Sep 2022',
    customer: '/assets/img/customer/user-04.jpg',
    customer1: '/assets/img/customer/user-05.jpg',
    customerName: 'Johnny',
    customerName1: 'Pricilla',
    amt: '$20',
    pending: 'Pending',
    reason: "I don't want this service.",
    bg: 'badge-pending',
  },
  {
    id: 7,
    profile: '/assets/img/services/service-03.jpg',
    texts: 'Steam Car Wash',
    dates: '15 Sep 2022',
    customer: '/assets/img/customer/user-06.jpg',
    customer1: '/assets/img/customer/user-02.jpg',
    customerName: 'Robert',
    customerName1: 'Amanda',
    amt: '$50',
    pending: 'Pending',
    reason: 'Testing',
    bg: 'badge-pending',
  },
  {
    id: 8,
    profile: '/assets/img/services/service-03.jpg',
    texts: 'House Cleaning',
    dates: '15 Sep 2022',
    customer: '/assets/img/customer/user-09.jpg',
    customer1: '/assets/img/customer/user-01.jpg',
    customerName: 'Sharonda',
    customerName1: 'James',
    amt: '$50',
    pending: 'Approved',
    reason: 'Just Testing Purpose.',
    bg: 'badge-active',
  },
];
